L.drawLocal = {
  draw: {
    toolbar: {
      actions: {
        title: "Cancelar desenho",
        text: "Cancelar",
      },
      finish: {
        title: "Finalizar desenho",
        text: "Finalizar",
      },
      undo: {
        title: "Excluir último ponto desenhado",
        text: "Excluir último ponto",
      },
      buttons: {
        polyline: "Desenhar uma linha",
        polygon: "Desenhar um polígono",
        rectangle: "Desenhar um retângulo",
        circle: "Desenhar um círculo",
        marker: "Adicionar um marcador",
        circlemarker: "Adicionar um marcador circular",
      },
    },
    handlers: {
      circle: {
        tooltip: {
          start: "Clique e arraste para desenhar um círculo.",
        },
        radius: "Raio",
      },
      circlemarker: {
        tooltip: {
          start: "Clique no mapa para posicionar o marcador circular.",
        },
      },
      marker: {
        tooltip: {
          start: "Clique no mapa para posicionar o marcador.",
        },
      },
      polygon: {
        tooltip: {
          start: "Clique para começar a desenhar a forma.",
          cont: "Clique para continuar desenhando a forma.",
          end: "Clique no primeiro ponto para fechar esta forma.",
        },
      },
      polyline: {
        error: "<strong>Erro:</strong> as bordas da forma não podem se cruzar!",
        tooltip: {
          start: "Clique para começar a desenhar a linha.",
          cont: "Clique para continuar desenhando a linha.",
          end: "Clique no último ponto para finalizar a linha.",
        },
      },
      rectangle: {
        tooltip: {
          start: "Clique e arraste para desenhar um retângulo.",
        },
      },
      simpleshape: {
        tooltip: {
          end: "Solte o mouse para finalizar o desenho.",
        },
      },
    },
  },
  edit: {
    toolbar: {
      actions: {
        save: {
          title: "Salvar alterações",
          text: "Salvar",
        },
        cancel: {
          title: "Cancelar edição, descarta todas as alterações",
          text: "Cancelar",
        },
        clearAll: {
          title: "Limpar todas as camadas",
          text: "Limpar Tudo",
        },
      },
      buttons: {
        edit: "Editar camadas",
        editDisabled: "Nenhuma camada para editar",
        remove: "Excluir camadas",
        removeDisabled: "Nenhuma camada para excluir",
      },
    },
    handlers: {
      edit: {
        tooltip: {
          text: "Arraste as alças ou marcadores para editar os elementos.",
          subtext: "Clique em cancelar para desfazer as alterações.",
        },
      },
      remove: {
        tooltip: {
          text: "Clique em um elemento para removê-lo.",
        },
      },
    },
  },
};
